import axios, { type CancelToken } from "axios";
import urlJoin from "url-join";
import type { BaseParams } from "../../../../client.types.js";
import type {
    GetPreviousPaymentAmountQuery,
    GetPreviousPaymentAmountResponse200,
} from "../../../../routes/private/Ambassadors/Payment/GetPreviousPaymentAmount/GetPreviousPaymentAmount.interfaces.js";
import type { GetPreviousPaymentAmount } from "./getPreviousPaymentAmount.types.js";

export type { GetPreviousPaymentAmountQuery, GetPreviousPaymentAmountResponse200 };
export const getPreviousPaymentAmount =
    ({
        baseUrl,
        headers,
        httpAgent,
        httpsAgent,
        adapter,
    }: BaseParams): GetPreviousPaymentAmount extends (...args: infer P) => infer R
        ? P extends []
            ? (params?: { cancelToken?: CancelToken }) => R
            : (
                  params: P[0] & {
                      cancelToken?: CancelToken;
                  },
              ) => R
        : never =>
    async (params) => {
        try {
            const { query } = params;
            const url = urlJoin(baseUrl, `ambassadors/payment/previous-amount`);
            const result = await axios.get<GetPreviousPaymentAmountResponse200>(url, {
                httpsAgent,
                httpAgent,
                headers,
                adapter,
                params: query,
                cancelToken: params?.cancelToken,
            });
            return { hasFailed: false, status: result.status, data: result.data };
        } catch (e: any) {
            if (axios.isAxiosError(e)) {
                if (e.response !== undefined) {
                    return {
                        hasFailed: true,
                        status: e.response.status,
                        error: {
                            code:
                                typeof e.response?.data?.code === "string" || typeof e.response?.data?.code === "number"
                                    ? String(e.response.data.code)
                                    : "UNKNOWN_ERROR",
                            message:
                                typeof e.response?.data?.message === "string"
                                    ? e.response.data.message
                                    : typeof e.response?.data === "string"
                                      ? e.response.data
                                      : "Unknown error",
                            raw: e.response.data,
                        },
                    };
                }
                if (e.request !== undefined) {
                    return {
                        hasFailed: true,
                        status: 503,
                        error: {
                            code: "SERVICE_UNAVAILABLE",
                            message: "Service unavailable",
                            raw: e.request,
                        },
                    };
                }
            }
            return {
                hasFailed: true,
                status: 500,
                error: {
                    code: "UNKNOWN_ERROR",
                    message: typeof e === "string" ? e : e instanceof Error ? e.message : "Unknown error",
                },
            };
        }
    };
